<div fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" class="container" [ngClass]="fontSizeClass">
    <h2 class="section-title">{{ options?.title || defaults.title }}</h2>
    <div
      fxLayout="row wrap"
      fxLayout.lt-md="column"
      fxFlex="100"
      fxLayoutGap="24px"
      fxLayoutAlign="center stretch"
      fxLayoutAlign.lt-md="center center"
    >
      @for (card of cardOrder; track card) {
        @if (card === 'priority' && options?.priorityCardVisible) {
          <div class="split-card priority-card" fxFlex fxLayout="column">
            <div class="card-header priority-header">
              <h2>{{ options?.priorityCardTitle || defaults.priorityCardTitle }}</h2>
            </div>
            <div class="card-body" fxFlex fxLayout="column">
              <div class="card-logo priority-logos" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
                @if (options?.charityLogo) {
                  <img [src]="options?.charityLogo | resolveUrl" alt="Charity logo" />
                }
                @if (options?.charityLogo) {
                  <span class="logo-plus">+</span>
                }
                <img src="/assets/images/rspl_logo.png" alt="ReSupply logo" />
              </div>
              <ul class="card-bullets">
                @for (bullet of priorityBullets; track bullet) {
                  <li>{{ bullet }}</li>
                }
              </ul>
              <div fxFlex></div>
              <button
                class="card-button priority-button"
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="8px"
                (click)="goToPrimary(sectionType)"
              >
                <span>{{ options?.priorityCardButtonText || defaults.priorityCardButtonText }}</span>
                <mat-icon svgIcon="ss3-arrow-right" />
              </button>
            </div>
          </div>
        }
        @if (card === 'standard' && options?.standardCardVisible) {
          <div class="split-card standard-card" fxFlex fxLayout="column">
            <div
              class="card-header standard-header"
              [style.background-color]="options?.standardCardHeaderBg || defaults.standardCardHeaderBg"
              [style.color]="options?.standardCardHeaderColor || defaults.standardCardHeaderColor"
            >
              <h2>{{ options?.standardCardTitle || defaults.standardCardTitle }}</h2>
            </div>
            <div
              class="card-body"
              fxFlex
              fxLayout="column"
              [style.background-color]="options?.standardCardBodyBg || defaults.standardCardBodyBg"
              [style.color]="options?.standardCardBodyColor || defaults.standardCardBodyColor"
            >
              @if (options?.charityLogo) {
                <div class="card-logo" fxLayout="row" fxLayoutAlign="center center">
                  <img [src]="options?.charityLogo | resolveUrl" alt="Charity logo" />
                </div>
              }
              <ul class="card-bullets">
                @for (bullet of standardBullets; track bullet) {
                  <li>{{ bullet }}</li>
                }
                @if (options?.standardCardHyperlink && options?.standardCardHyperlinkText) {
                  <li class="hyperlink-bullet">
                    <a class="hyperlink" [href]="options.standardCardHyperlinkUrl" target="_blank" rel="noopener">
                      {{ options.standardCardHyperlinkText }}
                      <mat-icon>open_in_new</mat-icon>
                    </a>
                  </li>
                }
              </ul>
              <div fxFlex></div>
              <button
                class="card-button"
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="8px"
                [style.background-color]="options?.standardCardButtonBg || defaults.standardCardButtonBg"
                [style.color]="options?.standardCardButtonColor || defaults.standardCardButtonColor"
                (click)="goToStandard()"
              >
                <span>{{ options?.standardCardButtonText || defaults.standardCardButtonText }}</span>
                <mat-icon svgIcon="ss3-arrow-right" />
              </button>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
